import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/docs-site/src/components/containers/MdxLayout.js";
import { Playground, PropsTable } from '@versionone/doc-components';
import { SpacedGroup } from './';
import { Button } from '../Button';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`SpacedGroups are great when you have variable width elements you want to uniformly space and wrap to the next line.`}</p>
    <h2>{`Horizontal spacing`}</h2>
    <Playground __position={0} __code={'<SpacedGroup direction=\"vertical\" xs={24}>\n    <SpacedGroup>\n      <Button variant=\"contained\">Standard\n      <Button variant=\"contained\" type=\"primary\">\n        Primary\n      </Button>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n      <Button variant=\"contained\">Standard</Button>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n      <Button variant=\"contained\">More Buttons</Button>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n      <Button variant=\"contained\">More Cowbell</Button>\n    </SpacedGroup>\n    <SpacedGroup>\n      <div>Standard</div>\n      <div>Primary</div>\n      <div>Disabled</div>\n    </SpacedGroup>\n  </SpacedGroup>\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Playground,
      PropsTable,
      SpacedGroup,
      Button
    }} mdxType="Playground">
  <SpacedGroup direction="vertical" xs={24} mdxType="SpacedGroup">
    <SpacedGroup mdxType="SpacedGroup">
      <Button variant="contained" mdxType="Button">Standard</Button>
      <Button variant="contained" type="primary" mdxType="Button">
        Primary
      </Button>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
      <Button variant="contained" mdxType="Button">Standard</Button>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
      <Button variant="contained" mdxType="Button">More Buttons</Button>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
      <Button variant="contained" mdxType="Button">More Cowbell</Button>
    </SpacedGroup>
    <SpacedGroup mdxType="SpacedGroup">
      <div>Standard</div>
      <div>Primary</div>
      <div>Disabled</div>
    </SpacedGroup>
  </SpacedGroup>
    </Playground>
    <h2>{`Vertical spacing`}</h2>
    <p>{`Spacing can apply to any elements.
The desire to have equal spacing among hetergeneous elements
highlights why individual components should not "own" the spacing outside themselves (margin).`}</p>
    <Playground __position={1} __code={'<SpacedGroup direction=\"vertical\" xs={24}>\n    <SpacedGroup direction=\"vertical\">\n      <Button variant=\"contained\">Standard\n      <Button variant=\"contained\" type=\"primary\">\n        Primary\n      </Button>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n    </SpacedGroup>\n    <SpacedGroup direction=\"vertical\">\n      <div>Standard</div>\n      <div>Primary</div>\n      <div>Disabled</div>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n      <div>Disabled</div>\n    </SpacedGroup>\n    <SpacedGroup direction=\"vertical\" center>\n      <div>Standard</div>\n      <div>Primary</div>\n      <div>Disabled</div>\n      <Button variant=\"contained\" disabled>\n        Disabled\n      </Button>\n      <div>Disabled</div>\n    </SpacedGroup>\n  </SpacedGroup>\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Playground,
      PropsTable,
      SpacedGroup,
      Button
    }} mdxType="Playground">
  <SpacedGroup direction="vertical" xs={24} mdxType="SpacedGroup">
    <SpacedGroup direction="vertical" mdxType="SpacedGroup">
      <Button variant="contained" mdxType="Button">Standard</Button>
      <Button variant="contained" type="primary" mdxType="Button">
        Primary
      </Button>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
    </SpacedGroup>
    <SpacedGroup direction="vertical" mdxType="SpacedGroup">
      <div>Standard</div>
      <div>Primary</div>
      <div>Disabled</div>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
      <div>Disabled</div>
    </SpacedGroup>
    <SpacedGroup direction="vertical" center mdxType="SpacedGroup">
      <div>Standard</div>
      <div>Primary</div>
      <div>Disabled</div>
      <Button variant="contained" disabled mdxType="Button">
        Disabled
      </Button>
      <div>Disabled</div>
    </SpacedGroup>
  </SpacedGroup>
    </Playground>
    <h2>{`Changing Screen Size`}</h2>
    <Playground __position={2} __code={'<SpacedGroup direction=\"vertical\" xs={0} sm={8} md={24}>\n    <div>Standard\n    <div>Primary</div>\n    <div>Disabled</div>\n  </SpacedGroup>\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Playground,
      PropsTable,
      SpacedGroup,
      Button
    }} mdxType="Playground">
  <SpacedGroup direction="vertical" xs={0} sm={8} md={24} mdxType="SpacedGroup">
    <div>Standard</div>
    <div>Primary</div>
    <div>Disabled</div>
  </SpacedGroup>
    </Playground>
    <h2>{`API`}</h2>
    <PropsTable of={SpacedGroup} mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      